module.exports = __webpack_public_path__ + "img/p__农林.e0032923.png";